import { ENVS } from "@config";
import { AppConfig } from "../../../../config/app-config";
import { TranslationService } from "@core-services/translation.service";
import { tokens } from "@bitpanda-design-system/theme";

export const PAYSAFE_CC_NAME_VALIDATION_REGEX: RegExp = /^(?!.* {2})(?=\S)(?=.*\S$)[A-Za-z\-.' ]*$/;
export const PAYSAFE_CC_NAME_VALIDATION_REGEX_KEYPRESS: RegExp = /[\p{L}\- '.]/u;
export const PAYSAFE_CC_NAME_VALIDATION_MIN_LENGTH: number = 3;
export const PAYSAFE_CC_NAME_VALIDATION_MAX_LENGTH: number = 36;
export const PAYSAFE_CC_NUMBER_DEFAULT_ALLOWED_BRANDS: VALID_CC_BRAND[] = ["visa"];
export const PAYSAFE_CC_NUMBER_DEFAULT_ERROR: string = "paysafe_cc_number_visa_primary_error";
export const PAYSAFE_CC_NUMBER_MC_AVAILABLE_ALLOWED_BRANDS: VALID_CC_BRAND[] = ["visa", "mastercard"];
export const PAYSAFE_CC_NUMBER_MC_AVAILABLE_ERROR: string = "paysafe_cc_number_visa_mc_primary_error";
export const PAYSAFE_GENERAL_FORM_ERROR_I18N_KEY: string = "paysafe_general_form_error";
export const PAYSAFE_PROCESSING_FIRST_STEP_DESCRIPTION_I18N_KEY: string = "processing_first_step_description";
export const PAYSAFE_PROCESSING_SECOND_STEP_DESCRIPTION_I18N_KEY: string = "processing_second_step_description";
export const PAYSAFE_TIMEOUT_COUNT: number = 10;
enum PAYSAFE_ENV {
	LIVE = "LIVE",
	TEST = "TEST"
}
export enum PAYSAFE_ERRORS {
	CONNECTION_TO_SERVER = "9001",
	COMMUNICATION_WITH_SERVER = "9002",
	INVALID_FIELDS = "9003",
	ENROLLMENT_NOT_ACCEPTED = "9039",
	AUTH_NOT_ACCEPTED = "9040",
	USER_ABORTED_AUTH = "9042"
}

export type CC_BRAND = "visa" | "mastercard" | "unknown";
export type UNKNOWN_CC_BRAND = "unknown";
export type VALID_CC_BRAND = Exclude<CC_BRAND, UNKNOWN_CC_BRAND>;

export interface PaysafeConfig {
	environment: PAYSAFE_ENV;
	fields: {
		[key: string]: {
			selector: string;
			placeholder: string;
		};
	};
	style: {
		input: {
			[key: string]: string;
		};
	};
}

export const paysafeInitialisationConfig = (
	config: AppConfig,
	translationService: TranslationService
): PaysafeConfig => ({
	environment: [ENVS.PROD, ENVS.BETA].includes(config.envName) ? PAYSAFE_ENV.LIVE : PAYSAFE_ENV.TEST,
	fields: {
		cardNumber: {
			selector: "#card-number",
			placeholder: translationService.translate("card_number")
		},
		expiryDate: {
			selector: "#expiry-date",
			placeholder: translationService.translate("date_format_MM_slash_YY")
		},
		cvv: {
			selector: "#cvv",
			placeholder: translationService.translate("cvv")
		}
	},
	style: {
		input: {
			"font-size": "17px",
			"font-family": tokens.typography.body.medium.fontFamily.value,
			"font-weight": "400",
			color: getComputedStyle(document.body).getPropertyValue("--color-neutral-75").trim()
		}
	}
});
